import { laborPageKeysEquivalent } from "@/pages/clampqc/clampQcLaborClockState";

import type { LaborSession } from "./laborApi";

/** Returns the open hub labor session id when it matches the expected floor wire page (for example `final-qc` or `pre-pack-job:1:2`). */
export function openLaborSessionIdForWirePage(
  session: LaborSession | null | undefined,
  wirePage: string,
): number | undefined {
  if (session == null || session.id <= 0) return undefined;
  const page = typeof session.page === "string" ? session.page.trim() : "";
  if (page === "" || !laborPageKeysEquivalent(page, wirePage)) return undefined;
  return session.id;
}
